


















































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../components/left-nav.vue";
import Pagination from "@/components/paginaiton.vue";
import UserDetail from "./user-detail.vue";
import {
  GetUsersList,
  SearchHospitalsList,
  SearchCentersList,
  ResetUserPassword,
  ChangeUserState,
} from "@/request/system";
@Component({
  components: {
    MainHeader,
    LeftNav,
    Pagination,
    UserDetail,
  },
})
export default class SystemUser extends Vue {
  // 搜索条件
  private hospitals: any[] = [];
  private centers: any[] = [];
  private filters: any = {
    hospital_id: "",
    project_id: "",
    search: "",
  };
  // 排序
  private cSortField: string = "创建时间";
  private cSortValue: string = "0";
  // 翻页
  private ifLoading: boolean = false;
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  private pageSize: any = 10;
  // 列表
  private users: any[] = [];
  // 添加用户
  private ifShowUserDetail: boolean = false;
  private detailType: any = "add";
  private targetUser: any = {};
  /**
   * @description 获得可选机构列表
   */
  private searchHospitals(ev) {
    const params: any = {
      search: ev,
    };
    SearchHospitalsList(this, params).then((data: any) => {
      this.hospitals = data;
      this.hospitals.unshift({ hospital_id: "", 医院名称: "全部机构" });
    });
  }
  /**
   * @description 获得可选数据中心列表
   */
  private searchCenters(ev) {
    const params: any = {
      search: ev,
    };
    SearchCentersList(this, params).then((data: any) => {
      this.centers = data;
      this.centers.unshift({ project_id: "", 名称: "全部数据中心" });
    });
  }
  /**
   * @description 获得用户列表
   */
  private getUsers() {
    const params: any = {
      search: this.filters.search,
      hospital_id: this.filters.hospital_id,
      project_id: this.filters.project_id,
      current_page: this.currentPage,
      page_count: this.pageSize,
      sort_value: this.cSortValue,
    };
    GetUsersList(this, params).then((data: any) => {
      this.users = data.users;
      this.totalPage = data.total_page;
      this.totalCount = data.total_count;
    });
  }
  /**
   * @description 新增用户
   */
  private addUser() {
    this.detailType = "add";
    this.targetUser = {};
    this.ifShowUserDetail = true;
  }
  /**
   * @description 关闭弹窗
   */
  private userDetailClose() {
    this.ifShowUserDetail = false;
  }
  /**
   * @description 新增用户后
   */
  private refresh() {
    this.ifShowUserDetail = false;
    if (this.detailType === "add") {
      this.currentPage = 1;
      this.cSortValue = "0";
      this.filters.hospital_id = "";
      this.filters.project_id = "";
      this.filters.search = "";
    }
    this.getUsers();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.getUsers();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.cSortField = ev["prop"];
    this.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.getUsers();
  }
  /**
   * @description 渲染专病数据库
   */
  private renderZhuanbing(scope) {
    const arr: any[] = [];
    if (scope.row["专病数据库"]) {
      scope.row["专病数据库"].map((item: any) => {
        arr.push(item["项目名称"]);
      });
      return arr.join(",");
    } else {
      return "";
    }
  }
  /**
   * @description 渲染所属机构
   */
  private renderSuoshujigou(scope) {
    const arr: any[] = [];
    if (scope.row["所属机构"]) {
      scope.row["所属机构"].map((item: any) => {
        arr.push(item["医院名称"]);
      });
      return arr.join(",");
    } else {
      return "";
    }
  }
  /**
   * @description 渲染四诊设备
   */
  private renderSizhenshebei(scope) {
    const arr: any[] = [];
    if (scope.row["四诊设备"]) {
      scope.row["四诊设备"].map((item: any) => {
        arr.push(item["医院名称"]);
      });
      return arr.join(",");
    } else {
      return "";
    }
  }
  /**
   * @description 编辑
   */
  private composeThis(user) {
    this.targetUser = user;
    console.log(user);
    this.detailType = "compose";
    this.ifShowUserDetail = true;
  }
  /**
   * @description 重置密码
   */
  private resetPassword(user) {
    const params: any = {
      user_id: user.user_id,
    };
    ResetUserPassword(this, params).then((data: any) => {
      this.$message.success("密码已重置");
    });
  }
  /**
   * @description 改变用户账号状态
   */
  private changeState(user) {
    const params: any = {
      user_id: user.user_id,
      action: user["状态"] === "正常" ? "禁用" : "启用",
    };
    ChangeUserState(this, params).then((data: any) => {
      this.$message.success("操作成功");
      this.getUsers();
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getUsers();
  }
}
